export default {
      id: "circle__shock-usage",
      viewBox: "0 0 28 27",
      url: __webpack_public_path__ + "img/icons.svg#circle__shock",
      toString: function () {
        return this.url;
      }
    }